module.exports = __webpack_public_path__ + "static/media/yash-research.067b6e21.png";